import { render, staticRenderFns } from "./MsgList.vue?vue&type=template&id=43c84911&scoped=true&"
import script from "./MsgList.vue?vue&type=script&lang=js&"
export * from "./MsgList.vue?vue&type=script&lang=js&"
import style0 from "./MsgList.vue?vue&type=style&index=0&id=43c84911&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c84911",
  null
  
)

export default component.exports